import { gqlFetcher, graphql } from '#features/api';
import { isDefined } from '#utils/isDefined';

export const landingPageDoc = graphql(`
  query LandingPage {
    page {
      main {
        title
        popularGames {
          id
          logo
          name
          previewImage
          slug
        }
      }
      landings {
        connectImage
        createdAt
        description
        id
        mainColor
        mainImage
        name
        previewImage
        published
        slug
        teamworkImage
        title
        keywords
        updatedAt
      }
    }
  }
`);

export const landingPageQueryOptions = (slug: string) => ({
  queryKey: ['landingPage', slug],
  queryFn: async () => {
    const data = await gqlFetcher(landingPageDoc, { slug });

    const landingPageData = data.page.landings?.find((landing) => {
      return landing?.slug === slug;
    });

    if (!landingPageData) {
      return null;
    }

    const popularGames = data.page.main?.popularGames
      ?.filter(isDefined)
      .filter((popularGame) => popularGame?.slug !== slug && isDefined(popularGame));

    return {
      ...landingPageData,
      popularGames,
    };
  },
});
